import { Component } from '@angular/core';
import { ModalService } from '../../services/modal.service';

@Component({
  selector: 'ng-casto-fence-infos-base-plate',
  templateUrl: './fence-infos-base-plate.component.html',
})
export class FenceInfosBasePlateComponent {
  constructor(public modalService: ModalService) {}
}
